<template>
  <div class="container">
    <div class="left">
      <img :src="icon" />
      {{
        type === "weight"
          ? `${$t("app.evolution.weight")} ${$t("app.evolution.weight-unit")}`
          : `${$t("app.evolution.length")} ${$t("app.evolution.length-unit")}`
      }}
    </div>
    <div class="right">
      <input
        type="number"
        :placeholder="type === 'weight' ? '1000' : '40'"
        v-model="val"
        @input="changed($event)"
      />
    </div>
  </div>
</template>

<script>
const weightIcon = require("@/assets/icons/kilo-pink.svg");
const rulerIcon = require("@/assets/icons/ruler-pink.svg");
export default {
  name: "ValueSelector",
  props: {
    type: null,
    negative: { default: true }
  },
  data() {
    return {
      icon: this.type === "weight" ? weightIcon : rulerIcon,
      val: ""
    };
  },
  methods: {
    changed: function(e) {
      const eVal = e.target.value;
      const parsedVal = Number.parseFloat(eVal);

      if (isNaN(parsedVal)) {
        this.$emit("change", null);
        return;
      }

      if (!this.negative && parsedVal < 0) {
        this.$emit("negative");
        return;
      }

      if (this.type === 'weight' && (parsedVal < 400 || parsedVal > 10000)) {
        this.$emit("negative");
        return;
      }

      if (this.type === 'length' && (parsedVal < 15 || parsedVal > 150)) {
        this.$emit("negative");
        return;
      }

      this.$emit("change", parsedVal);
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  align-items: center;

  height: 40px;
  border: 2px solid #31b9be;
  border-radius: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.left,
.right {
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
}

.left {
  justify-content: flex-start;
  padding-right: 20px;
  border-right: 2px solid #31b9be;
}

.right {
  justify-content: flex-start;
  padding-left: 20px;
}

input {
  border: 0;
  height: 36px;
  max-width: 100%;
}

img {
  width: auto;
  max-height: 30px;
  margin: 0;
}

input::placeholder {
  color: #8a8a8a;
  font-family: "OpenSans";
  font-size: 14px;
}
</style>
